'use strict';

angular.module('teams').factory('UserGroups', ['$resource',
    function($resource) {
        return $resource('v1/teams/:teamId/user-groups/:userGroupId', { teamId: '@_id', userGroupId: '@_id'
        }, {
            update: {
                method: 'PUT'
            },
            save: {
                url: 'v1/teams/:teamId/user-groups',
				method: 'POST'
            },
            remove: {
                url: 'v1/teams/:teamId/user-groups/:userGroupId',
                method: 'DELETE'
            }
        });
    }
]);